import { nullish } from '@getstep/sdk/dist/util/Assert'
import { produce } from 'immer'

import { makeUseQueryHook } from '@graphql/functions'
import { EMPTY_RECEIPT } from '@graphql/placeholders'
import { GetReceiptDocument } from '@graphql/queries/GetReceipt.graphql'
import { usePersonalizations } from '@lib/hooks/usePersonalizations'
import { renderTemplate } from '@lib/utils/text'

/**
 * Returns the personalized content for a receipt.
 */
export const useReceipt = (
    id: string,
    passedInPersonalizations?: Record<string, any>,
) => {
    const localPersonalizations = usePersonalizations()
    const result = useGetReceipt({ variables: { id } })

    const personalizations = passedInPersonalizations ?? localPersonalizations

    const receipt = produce(result.data?.receipt ?? EMPTY_RECEIPT, (draft) => {
        const { items } = draft

        if (items) {
            for (const item of items.items) {
                if (nullish(item)) continue
                item.term = renderTemplate(item.term, personalizations)
                item.definition = renderTemplate(
                    item.definition,
                    personalizations,
                )
            }
        }
    })

    return { receipt, ...result }
}

const useGetReceipt = makeUseQueryHook({
    query: GetReceiptDocument,
})
